// @flow

import React from 'react';
import styled from 'styled-components';
import ContactOption from '../contactOption';
import type { EnrichedContactOption } from './types';
import type { Theme } from '../../types';

type OwnProps = {
  contactOptions: Array<EnrichedContactOption>, // eslint-disable-line react/require-default-props
};

type Props = OwnProps;

const StyledContactOption = styled<typeof ContactOption, Theme>(ContactOption)`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const DirectContact = ({
  contactOptions,
}: Props) => (
  <section>
    {contactOptions.length > 0 && contactOptions.map(option => (
      <StyledContactOption
        key={`${option.href || ''}-${option.value}`}
        icon={option.icon.value}
        link={option.href}
        title={option.value}
        subtitle={option.subtitle}
      />
    ))}
  </section>
);

export default DirectContact;
